export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="section-container section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-sm"></i>
              </div>
              <span className="text-lg font-heading text-background-50 font-bold">青青草视频</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              青青草视频聚合香蕉视频、红桃视频、91视频、蜜桃视频等热门影视平台，
              提供高清免费在线观看体验，致力于成为用户发现优质影视品牌的第一入口。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer">
                <i className="ri-arrow-up-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">快速导航</h3>
            <div className="flex flex-col gap-2.5">
              <a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热门排行</a>
              <a href="#cards" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">精选推荐</a>
              <a href="#updates" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">最新动态</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">专题合集</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">影视平台</h3>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-background-400">香蕉视频</span>
              <span className="text-sm text-background-400">红桃视频</span>
              <span className="text-sm text-background-400">91视频</span>
              <span className="text-sm text-background-400">蜜桃视频</span>
              <span className="text-sm text-background-400">樱花视频</span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500 leading-relaxed">
              更多优质影视平台持续接入中，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 青青草视频 - 影视品牌聚合平台。本站为影视平台导航与内容聚合入口，不存储任何视频文件。
          </p>
          <p className="text-xs text-background-600">
            高清免费在线观看 · 不缓冲播放体验
          </p>
        </div>
      </div>
    </footer>
  );
}